const errorMsg = 'Please fill this field.';
const failedMsg = 'Bad request';
const customErrorMsg = (value: string) => `Are you sure you entered ${value} correctly`;

export { errorMsg, failedMsg, customErrorMsg };
